import React from 'react';

export default class PhotoRow extends React.Component {
 /* constructor(props) {
    super(props);
  }*/

  render() {
    const {RowData, UserReducer} = this.props
    let sty = { backgroundImage: 'url(' + RowData.URL + "&token=" + UserReducer.token + ')'}
    return (
      <div className="col-md-6">
        <div className="card card-photo">
          <div className="card-block img-same-size-wrapper">
            <div className="img-same-size" style={sty}></div>
          </div>
          <div className="overlay"></div>
          <div className="card-action-center">
            <button 
              title="Delete this image" 
              className="btn btn-delete-photo" 
              onClick={()=> this.props.onDelete(RowData.Alias)}><i className="icon-trash"></i>
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/photo/helper/component/PhotoRow.js